/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OEX API
 * Operators Exchange REST API (docs/08). Org-scoped routes take the active organisation in X-Org-Id; errors are RFC 7807 problem details with a `code`.
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInvitationResultDto,
  AdminUserDto,
  AdminUserListDto,
  AuthCallbackDto,
  AuthConfigDto,
  AuthRefreshDto,
  AuthSessionDto,
  CreateGrantDto,
  CreateInvitationDto,
  CreateJoinRequestDto,
  DecideJoinRequestDto,
  DevTokenDto,
  GrantStaffRoleDto,
  IdentityListAdminJoinRequestsParams,
  IdentityListAdminUsersParams,
  ImpersonationDto,
  ImpersonationListDto,
  InvitationDto,
  InvitationListDto,
  InvitationPreviewDto,
  JoinRequestDto,
  JoinRequestListDto,
  MeDto,
  MemberDto,
  MemberListDto,
  MintDevTokenDto,
  OwnershipTransferResultDto,
  PermissionGrantDto,
  PermissionGrantListDto,
  RemoveMemberResultDto,
  StaffDto,
  StaffListDto,
  StartImpersonationDto,
  StartedImpersonationDto,
  TransferOwnershipDto,
  UpdateMeDto,
  UpdateMemberDto,
  UserDto,
  WebhookAckDto
} from '../../model';

import { oexFetch } from '../../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getIdentityStartImpersonationUrl = () => {




  return `/v1/admin/impersonations`
}

export const identityStartImpersonation = async (startImpersonationDto: StartImpersonationDto, options?: Parameters<typeof oexFetch>[1]): Promise<StartedImpersonationDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<StartedImpersonationDto>(getIdentityStartImpersonationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(startImpersonationDto)
  }
);}





export const getIdentityStartImpersonationMutationKey = () => ['identityStartImpersonation'] as const;

export const getIdentityStartImpersonationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityStartImpersonation>>, TError,IdentityStartImpersonationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityStartImpersonation>>, TError,IdentityStartImpersonationMutationVariables, TContext> => {

const mutationKey = getIdentityStartImpersonationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityStartImpersonation>>, IdentityStartImpersonationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityStartImpersonation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityStartImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof identityStartImpersonation>>>
    export type IdentityStartImpersonationMutationBody = StartImpersonationDto
    export type IdentityStartImpersonationMutationError = unknown
    export type IdentityStartImpersonationMutationVariables = {data: StartImpersonationDto}

    export const useIdentityStartImpersonation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityStartImpersonation>>, TError,IdentityStartImpersonationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityStartImpersonation>>,
        TError,
        IdentityStartImpersonationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityStartImpersonationMutationOptions(options), queryClient);
    }
    export const getIdentityListImpersonationsUrl = () => {




  return `/v1/admin/impersonations`
}

export const identityListImpersonations = async ( options?: Parameters<typeof oexFetch>[1]): Promise<ImpersonationListDto> => {

  return oexFetch<ImpersonationListDto>(getIdentityListImpersonationsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListImpersonationsQueryKey = () => {
    return [
    `/v1/admin/impersonations`
    ] as const;
    }


export const getIdentityListImpersonationsQueryOptions = <TData = Awaited<ReturnType<typeof identityListImpersonations>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListImpersonationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListImpersonations>>> = ({ signal }) => identityListImpersonations({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListImpersonationsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListImpersonations>>>
export type IdentityListImpersonationsQueryError = unknown


export function useIdentityListImpersonations<TData = Awaited<ReturnType<typeof identityListImpersonations>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListImpersonations>>,
          TError,
          Awaited<ReturnType<typeof identityListImpersonations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListImpersonations<TData = Awaited<ReturnType<typeof identityListImpersonations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListImpersonations>>,
          TError,
          Awaited<ReturnType<typeof identityListImpersonations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListImpersonations<TData = Awaited<ReturnType<typeof identityListImpersonations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListImpersonations<TData = Awaited<ReturnType<typeof identityListImpersonations>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListImpersonations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListImpersonationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityEndImpersonationUrl = (id: string,) => {




  return `/v1/admin/impersonations/${id}/end`
}

export const identityEndImpersonation = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<ImpersonationDto> => {

  return oexFetch<ImpersonationDto>(getIdentityEndImpersonationUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityEndImpersonationMutationKey = () => ['identityEndImpersonation'] as const;

export const getIdentityEndImpersonationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityEndImpersonation>>, TError,IdentityEndImpersonationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityEndImpersonation>>, TError,IdentityEndImpersonationMutationVariables, TContext> => {

const mutationKey = getIdentityEndImpersonationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityEndImpersonation>>, IdentityEndImpersonationMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  identityEndImpersonation(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityEndImpersonationMutationResult = NonNullable<Awaited<ReturnType<typeof identityEndImpersonation>>>

    export type IdentityEndImpersonationMutationError = unknown
    export type IdentityEndImpersonationMutationVariables = {id: string}

    export const useIdentityEndImpersonation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityEndImpersonation>>, TError,IdentityEndImpersonationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityEndImpersonation>>,
        TError,
        IdentityEndImpersonationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityEndImpersonationMutationOptions(options), queryClient);
    }
    export const getIdentityListAdminJoinRequestsUrl = (params?: IdentityListAdminJoinRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/join-requests?${stringifiedParams}` : `/v1/admin/join-requests`
}

/**
 * @summary Join requests of every org, pending first (the claims and joins queue)
 */
export const identityListAdminJoinRequests = async (params?: IdentityListAdminJoinRequestsParams, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestListDto> => {

  return oexFetch<JoinRequestListDto>(getIdentityListAdminJoinRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListAdminJoinRequestsQueryKey = (params?: IdentityListAdminJoinRequestsParams,) => {
    return [
    `/v1/admin/join-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getIdentityListAdminJoinRequestsQueryOptions = <TData = Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError = unknown>(params?: IdentityListAdminJoinRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListAdminJoinRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListAdminJoinRequests>>> = ({ signal }) => identityListAdminJoinRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListAdminJoinRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListAdminJoinRequests>>>
export type IdentityListAdminJoinRequestsQueryError = unknown


export function useIdentityListAdminJoinRequests<TData = Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError = unknown>(
 params: undefined |  IdentityListAdminJoinRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListAdminJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListAdminJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListAdminJoinRequests<TData = Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError = unknown>(
 params?: IdentityListAdminJoinRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListAdminJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListAdminJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListAdminJoinRequests<TData = Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError = unknown>(
 params?: IdentityListAdminJoinRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Join requests of every org, pending first (the claims and joins queue)
 */

export function useIdentityListAdminJoinRequests<TData = Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError = unknown>(
 params?: IdentityListAdminJoinRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListAdminJoinRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityAdminDecideJoinRequestUrl = (id: string,) => {




  return `/v1/admin/join-requests/${id}/decide`
}

export const identityAdminDecideJoinRequest = async (id: string,
    decideJoinRequestDto: DecideJoinRequestDto, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<JoinRequestDto>(getIdentityAdminDecideJoinRequestUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(decideJoinRequestDto)
  }
);}





export const getIdentityAdminDecideJoinRequestMutationKey = () => ['identityAdminDecideJoinRequest'] as const;

export const getIdentityAdminDecideJoinRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>, TError,IdentityAdminDecideJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>, TError,IdentityAdminDecideJoinRequestMutationVariables, TContext> => {

const mutationKey = getIdentityAdminDecideJoinRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>, IdentityAdminDecideJoinRequestMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  identityAdminDecideJoinRequest(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityAdminDecideJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>>
    export type IdentityAdminDecideJoinRequestMutationBody = DecideJoinRequestDto
    export type IdentityAdminDecideJoinRequestMutationError = unknown
    export type IdentityAdminDecideJoinRequestMutationVariables = {id: string;data: DecideJoinRequestDto}

    export const useIdentityAdminDecideJoinRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>, TError,IdentityAdminDecideJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityAdminDecideJoinRequest>>,
        TError,
        IdentityAdminDecideJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityAdminDecideJoinRequestMutationOptions(options), queryClient);
    }
    export const getIdentityListStaffUrl = () => {




  return `/v1/admin/staff`
}

export const identityListStaff = async ( options?: Parameters<typeof oexFetch>[1]): Promise<StaffListDto> => {

  return oexFetch<StaffListDto>(getIdentityListStaffUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListStaffQueryKey = () => {
    return [
    `/v1/admin/staff`
    ] as const;
    }


export const getIdentityListStaffQueryOptions = <TData = Awaited<ReturnType<typeof identityListStaff>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListStaffQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListStaff>>> = ({ signal }) => identityListStaff({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListStaffQueryResult = NonNullable<Awaited<ReturnType<typeof identityListStaff>>>
export type IdentityListStaffQueryError = unknown


export function useIdentityListStaff<TData = Awaited<ReturnType<typeof identityListStaff>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListStaff>>,
          TError,
          Awaited<ReturnType<typeof identityListStaff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListStaff<TData = Awaited<ReturnType<typeof identityListStaff>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListStaff>>,
          TError,
          Awaited<ReturnType<typeof identityListStaff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListStaff<TData = Awaited<ReturnType<typeof identityListStaff>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListStaff<TData = Awaited<ReturnType<typeof identityListStaff>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListStaff>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListStaffQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityGrantStaffRoleUrl = () => {




  return `/v1/admin/staff`
}

export const identityGrantStaffRole = async (grantStaffRoleDto: GrantStaffRoleDto, options?: Parameters<typeof oexFetch>[1]): Promise<StaffDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<StaffDto>(getIdentityGrantStaffRoleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantStaffRoleDto)
  }
);}





export const getIdentityGrantStaffRoleMutationKey = () => ['identityGrantStaffRole'] as const;

export const getIdentityGrantStaffRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityGrantStaffRole>>, TError,IdentityGrantStaffRoleMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityGrantStaffRole>>, TError,IdentityGrantStaffRoleMutationVariables, TContext> => {

const mutationKey = getIdentityGrantStaffRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityGrantStaffRole>>, IdentityGrantStaffRoleMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityGrantStaffRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityGrantStaffRoleMutationResult = NonNullable<Awaited<ReturnType<typeof identityGrantStaffRole>>>
    export type IdentityGrantStaffRoleMutationBody = GrantStaffRoleDto
    export type IdentityGrantStaffRoleMutationError = unknown
    export type IdentityGrantStaffRoleMutationVariables = {data: GrantStaffRoleDto}

    export const useIdentityGrantStaffRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityGrantStaffRole>>, TError,IdentityGrantStaffRoleMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityGrantStaffRole>>,
        TError,
        IdentityGrantStaffRoleMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityGrantStaffRoleMutationOptions(options), queryClient);
    }
    export const getIdentityRevokeStaffRoleUrl = (userId: string,) => {




  return `/v1/admin/staff/${userId}`
}

export const identityRevokeStaffRole = async (userId: string, options?: Parameters<typeof oexFetch>[1]): Promise<StaffDto> => {

  return oexFetch<StaffDto>(getIdentityRevokeStaffRoleUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getIdentityRevokeStaffRoleMutationKey = () => ['identityRevokeStaffRole'] as const;

export const getIdentityRevokeStaffRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeStaffRole>>, TError,IdentityRevokeStaffRoleMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityRevokeStaffRole>>, TError,IdentityRevokeStaffRoleMutationVariables, TContext> => {

const mutationKey = getIdentityRevokeStaffRoleMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityRevokeStaffRole>>, IdentityRevokeStaffRoleMutationVariables> = (props) => {
          const {userId} = props ?? {};

          return  identityRevokeStaffRole(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityRevokeStaffRoleMutationResult = NonNullable<Awaited<ReturnType<typeof identityRevokeStaffRole>>>

    export type IdentityRevokeStaffRoleMutationError = unknown
    export type IdentityRevokeStaffRoleMutationVariables = {userId: string}

    export const useIdentityRevokeStaffRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeStaffRole>>, TError,IdentityRevokeStaffRoleMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityRevokeStaffRole>>,
        TError,
        IdentityRevokeStaffRoleMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityRevokeStaffRoleMutationOptions(options), queryClient);
    }
    export const getIdentityListAdminUsersUrl = (params?: IdentityListAdminUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/users?${stringifiedParams}` : `/v1/admin/users`
}

export const identityListAdminUsers = async (params?: IdentityListAdminUsersParams, options?: Parameters<typeof oexFetch>[1]): Promise<AdminUserListDto> => {

  return oexFetch<AdminUserListDto>(getIdentityListAdminUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListAdminUsersQueryKey = (params?: IdentityListAdminUsersParams,) => {
    return [
    `/v1/admin/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getIdentityListAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof identityListAdminUsers>>, TError = unknown>(params?: IdentityListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListAdminUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListAdminUsers>>> = ({ signal }) => identityListAdminUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof identityListAdminUsers>>>
export type IdentityListAdminUsersQueryError = unknown


export function useIdentityListAdminUsers<TData = Awaited<ReturnType<typeof identityListAdminUsers>>, TError = unknown>(
 params: undefined |  IdentityListAdminUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof identityListAdminUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListAdminUsers<TData = Awaited<ReturnType<typeof identityListAdminUsers>>, TError = unknown>(
 params?: IdentityListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof identityListAdminUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListAdminUsers<TData = Awaited<ReturnType<typeof identityListAdminUsers>>, TError = unknown>(
 params?: IdentityListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListAdminUsers<TData = Awaited<ReturnType<typeof identityListAdminUsers>>, TError = unknown>(
 params?: IdentityListAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListAdminUsers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityGetAdminUserUrl = (id: string,) => {




  return `/v1/admin/users/${id}`
}

export const identityGetAdminUser = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<AdminUserDto> => {

  return oexFetch<AdminUserDto>(getIdentityGetAdminUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityGetAdminUserQueryKey = (id: string,) => {
    return [
    `/v1/admin/users/${id}`
    ] as const;
    }


export const getIdentityGetAdminUserQueryOptions = <TData = Awaited<ReturnType<typeof identityGetAdminUser>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityGetAdminUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityGetAdminUser>>> = ({ signal }) => identityGetAdminUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityGetAdminUserQueryResult = NonNullable<Awaited<ReturnType<typeof identityGetAdminUser>>>
export type IdentityGetAdminUserQueryError = unknown


export function useIdentityGetAdminUser<TData = Awaited<ReturnType<typeof identityGetAdminUser>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetAdminUser>>,
          TError,
          Awaited<ReturnType<typeof identityGetAdminUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetAdminUser<TData = Awaited<ReturnType<typeof identityGetAdminUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetAdminUser>>,
          TError,
          Awaited<ReturnType<typeof identityGetAdminUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetAdminUser<TData = Awaited<ReturnType<typeof identityGetAdminUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityGetAdminUser<TData = Awaited<ReturnType<typeof identityGetAdminUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAdminUser>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityGetAdminUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityDisableUserUrl = (id: string,) => {




  return `/v1/admin/users/${id}/disable`
}

export const identityDisableUser = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<AdminUserDto> => {

  return oexFetch<AdminUserDto>(getIdentityDisableUserUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityDisableUserMutationKey = () => ['identityDisableUser'] as const;

export const getIdentityDisableUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityDisableUser>>, TError,IdentityDisableUserMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityDisableUser>>, TError,IdentityDisableUserMutationVariables, TContext> => {

const mutationKey = getIdentityDisableUserMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityDisableUser>>, IdentityDisableUserMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  identityDisableUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityDisableUserMutationResult = NonNullable<Awaited<ReturnType<typeof identityDisableUser>>>

    export type IdentityDisableUserMutationError = unknown
    export type IdentityDisableUserMutationVariables = {id: string}

    export const useIdentityDisableUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityDisableUser>>, TError,IdentityDisableUserMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityDisableUser>>,
        TError,
        IdentityDisableUserMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityDisableUserMutationOptions(options), queryClient);
    }
    export const getIdentityAuthCallbackUrl = () => {




  return `/v1/auth/callback`
}

/**
 * @summary Exchange a hosted sign-in authorization code for a bearer token
 */
export const identityAuthCallback = async (authCallbackDto: AuthCallbackDto, options?: Parameters<typeof oexFetch>[1]): Promise<AuthSessionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<AuthSessionDto>(getIdentityAuthCallbackUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(authCallbackDto)
  }
);}





export const getIdentityAuthCallbackMutationKey = () => ['identityAuthCallback'] as const;

export const getIdentityAuthCallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAuthCallback>>, TError,IdentityAuthCallbackMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityAuthCallback>>, TError,IdentityAuthCallbackMutationVariables, TContext> => {

const mutationKey = getIdentityAuthCallbackMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityAuthCallback>>, IdentityAuthCallbackMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityAuthCallback(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityAuthCallbackMutationResult = NonNullable<Awaited<ReturnType<typeof identityAuthCallback>>>
    export type IdentityAuthCallbackMutationBody = AuthCallbackDto
    export type IdentityAuthCallbackMutationError = unknown
    export type IdentityAuthCallbackMutationVariables = {data: AuthCallbackDto}

    /**
 * @summary Exchange a hosted sign-in authorization code for a bearer token
 */
export const useIdentityAuthCallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAuthCallback>>, TError,IdentityAuthCallbackMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityAuthCallback>>,
        TError,
        IdentityAuthCallbackMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityAuthCallbackMutationOptions(options), queryClient);
    }
    export const getIdentityGetAuthConfigUrl = () => {




  return `/v1/auth/config`
}

/**
 * @summary Which identity provider signs users in, and its hosted pages
 */
export const identityGetAuthConfig = async ( options?: Parameters<typeof oexFetch>[1]): Promise<AuthConfigDto> => {

  return oexFetch<AuthConfigDto>(getIdentityGetAuthConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityGetAuthConfigQueryKey = () => {
    return [
    `/v1/auth/config`
    ] as const;
    }


export const getIdentityGetAuthConfigQueryOptions = <TData = Awaited<ReturnType<typeof identityGetAuthConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityGetAuthConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityGetAuthConfig>>> = ({ signal }) => identityGetAuthConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityGetAuthConfigQueryResult = NonNullable<Awaited<ReturnType<typeof identityGetAuthConfig>>>
export type IdentityGetAuthConfigQueryError = unknown


export function useIdentityGetAuthConfig<TData = Awaited<ReturnType<typeof identityGetAuthConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetAuthConfig>>,
          TError,
          Awaited<ReturnType<typeof identityGetAuthConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetAuthConfig<TData = Awaited<ReturnType<typeof identityGetAuthConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetAuthConfig>>,
          TError,
          Awaited<ReturnType<typeof identityGetAuthConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetAuthConfig<TData = Awaited<ReturnType<typeof identityGetAuthConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Which identity provider signs users in, and its hosted pages
 */

export function useIdentityGetAuthConfig<TData = Awaited<ReturnType<typeof identityGetAuthConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetAuthConfig>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityGetAuthConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityMintDevTokenUrl = () => {




  return `/v1/auth/dev-token`
}

/**
 * @summary Mint a dev token (non-production only)
 */
export const identityMintDevToken = async (mintDevTokenDto: MintDevTokenDto, options?: Parameters<typeof oexFetch>[1]): Promise<DevTokenDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<DevTokenDto>(getIdentityMintDevTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mintDevTokenDto)
  }
);}





export const getIdentityMintDevTokenMutationKey = () => ['identityMintDevToken'] as const;

export const getIdentityMintDevTokenMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityMintDevToken>>, TError,IdentityMintDevTokenMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityMintDevToken>>, TError,IdentityMintDevTokenMutationVariables, TContext> => {

const mutationKey = getIdentityMintDevTokenMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityMintDevToken>>, IdentityMintDevTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityMintDevToken(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityMintDevTokenMutationResult = NonNullable<Awaited<ReturnType<typeof identityMintDevToken>>>
    export type IdentityMintDevTokenMutationBody = MintDevTokenDto
    export type IdentityMintDevTokenMutationError = unknown
    export type IdentityMintDevTokenMutationVariables = {data: MintDevTokenDto}

    /**
 * @summary Mint a dev token (non-production only)
 */
export const useIdentityMintDevToken = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityMintDevToken>>, TError,IdentityMintDevTokenMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityMintDevToken>>,
        TError,
        IdentityMintDevTokenMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityMintDevTokenMutationOptions(options), queryClient);
    }
    export const getIdentityAuthRefreshUrl = () => {




  return `/v1/auth/refresh`
}

/**
 * @summary Exchange a refresh token for a fresh access token
 */
export const identityAuthRefresh = async (authRefreshDto: AuthRefreshDto, options?: Parameters<typeof oexFetch>[1]): Promise<AuthSessionDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<AuthSessionDto>(getIdentityAuthRefreshUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(authRefreshDto)
  }
);}





export const getIdentityAuthRefreshMutationKey = () => ['identityAuthRefresh'] as const;

export const getIdentityAuthRefreshMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAuthRefresh>>, TError,IdentityAuthRefreshMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityAuthRefresh>>, TError,IdentityAuthRefreshMutationVariables, TContext> => {

const mutationKey = getIdentityAuthRefreshMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityAuthRefresh>>, IdentityAuthRefreshMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityAuthRefresh(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof identityAuthRefresh>>>
    export type IdentityAuthRefreshMutationBody = AuthRefreshDto
    export type IdentityAuthRefreshMutationError = unknown
    export type IdentityAuthRefreshMutationVariables = {data: AuthRefreshDto}

    /**
 * @summary Exchange a refresh token for a fresh access token
 */
export const useIdentityAuthRefresh = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAuthRefresh>>, TError,IdentityAuthRefreshMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityAuthRefresh>>,
        TError,
        IdentityAuthRefreshMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityAuthRefreshMutationOptions(options), queryClient);
    }
    export const getIdentityPreviewInvitationUrl = (token: string,) => {




  return `/v1/invitations/${token}`
}

export const identityPreviewInvitation = async (token: string, options?: Parameters<typeof oexFetch>[1]): Promise<InvitationPreviewDto> => {

  return oexFetch<InvitationPreviewDto>(getIdentityPreviewInvitationUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityPreviewInvitationQueryKey = (token: string,) => {
    return [
    `/v1/invitations/${token}`
    ] as const;
    }


export const getIdentityPreviewInvitationQueryOptions = <TData = Awaited<ReturnType<typeof identityPreviewInvitation>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityPreviewInvitationQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityPreviewInvitation>>> = ({ signal }) => identityPreviewInvitation(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: token !== null && token !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityPreviewInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof identityPreviewInvitation>>>
export type IdentityPreviewInvitationQueryError = unknown


export function useIdentityPreviewInvitation<TData = Awaited<ReturnType<typeof identityPreviewInvitation>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityPreviewInvitation>>,
          TError,
          Awaited<ReturnType<typeof identityPreviewInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityPreviewInvitation<TData = Awaited<ReturnType<typeof identityPreviewInvitation>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityPreviewInvitation>>,
          TError,
          Awaited<ReturnType<typeof identityPreviewInvitation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityPreviewInvitation<TData = Awaited<ReturnType<typeof identityPreviewInvitation>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityPreviewInvitation<TData = Awaited<ReturnType<typeof identityPreviewInvitation>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityPreviewInvitation>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityPreviewInvitationQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityAcceptInvitationUrl = (token: string,) => {




  return `/v1/invitations/${token}/accept`
}

export const identityAcceptInvitation = async (token: string, options?: Parameters<typeof oexFetch>[1]): Promise<AcceptInvitationResultDto> => {

  return oexFetch<AcceptInvitationResultDto>(getIdentityAcceptInvitationUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityAcceptInvitationMutationKey = () => ['identityAcceptInvitation'] as const;

export const getIdentityAcceptInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAcceptInvitation>>, TError,IdentityAcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityAcceptInvitation>>, TError,IdentityAcceptInvitationMutationVariables, TContext> => {

const mutationKey = getIdentityAcceptInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityAcceptInvitation>>, IdentityAcceptInvitationMutationVariables> = (props) => {
          const {token} = props ?? {};

          return  identityAcceptInvitation(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityAcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof identityAcceptInvitation>>>

    export type IdentityAcceptInvitationMutationError = unknown
    export type IdentityAcceptInvitationMutationVariables = {token: string}

    export const useIdentityAcceptInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityAcceptInvitation>>, TError,IdentityAcceptInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityAcceptInvitation>>,
        TError,
        IdentityAcceptInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityAcceptInvitationMutationOptions(options), queryClient);
    }
    export const getIdentityGetMeUrl = () => {




  return `/v1/me`
}

/**
 * @summary Current user, memberships, entitlements, pending requests
 */
export const identityGetMe = async ( options?: Parameters<typeof oexFetch>[1]): Promise<MeDto> => {

  return oexFetch<MeDto>(getIdentityGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityGetMeQueryKey = () => {
    return [
    `/v1/me`
    ] as const;
    }


export const getIdentityGetMeQueryOptions = <TData = Awaited<ReturnType<typeof identityGetMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityGetMe>>> = ({ signal }) => identityGetMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof identityGetMe>>>
export type IdentityGetMeQueryError = unknown


export function useIdentityGetMe<TData = Awaited<ReturnType<typeof identityGetMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetMe>>,
          TError,
          Awaited<ReturnType<typeof identityGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetMe<TData = Awaited<ReturnType<typeof identityGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityGetMe>>,
          TError,
          Awaited<ReturnType<typeof identityGetMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityGetMe<TData = Awaited<ReturnType<typeof identityGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Current user, memberships, entitlements, pending requests
 */

export function useIdentityGetMe<TData = Awaited<ReturnType<typeof identityGetMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityGetMe>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityUpdateMeUrl = () => {




  return `/v1/me`
}

/**
 * @summary Update my profile
 */
export const identityUpdateMe = async (updateMeDto: UpdateMeDto, options?: Parameters<typeof oexFetch>[1]): Promise<UserDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<UserDto>(getIdentityUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMeDto)
  }
);}





export const getIdentityUpdateMeMutationKey = () => ['identityUpdateMe'] as const;

export const getIdentityUpdateMeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMe>>, TError,IdentityUpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMe>>, TError,IdentityUpdateMeMutationVariables, TContext> => {

const mutationKey = getIdentityUpdateMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityUpdateMe>>, IdentityUpdateMeMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityUpdateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityUpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof identityUpdateMe>>>
    export type IdentityUpdateMeMutationBody = UpdateMeDto
    export type IdentityUpdateMeMutationError = unknown
    export type IdentityUpdateMeMutationVariables = {data: UpdateMeDto}

    /**
 * @summary Update my profile
 */
export const useIdentityUpdateMe = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMe>>, TError,IdentityUpdateMeMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityUpdateMe>>,
        TError,
        IdentityUpdateMeMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityUpdateMeMutationOptions(options), queryClient);
    }
    export const getIdentityListMyJoinRequestsUrl = () => {




  return `/v1/me/join-requests`
}

export const identityListMyJoinRequests = async ( options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestListDto> => {

  return oexFetch<JoinRequestListDto>(getIdentityListMyJoinRequestsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListMyJoinRequestsQueryKey = () => {
    return [
    `/v1/me/join-requests`
    ] as const;
    }


export const getIdentityListMyJoinRequestsQueryOptions = <TData = Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListMyJoinRequestsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListMyJoinRequests>>> = ({ signal }) => identityListMyJoinRequests({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListMyJoinRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListMyJoinRequests>>>
export type IdentityListMyJoinRequestsQueryError = unknown


export function useIdentityListMyJoinRequests<TData = Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListMyJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListMyJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListMyJoinRequests<TData = Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListMyJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListMyJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListMyJoinRequests<TData = Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListMyJoinRequests<TData = Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMyJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListMyJoinRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityCreateJoinRequestUrl = () => {




  return `/v1/me/join-requests`
}

export const identityCreateJoinRequest = async (createJoinRequestDto: CreateJoinRequestDto, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<JoinRequestDto>(getIdentityCreateJoinRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createJoinRequestDto)
  }
);}





export const getIdentityCreateJoinRequestMutationKey = () => ['identityCreateJoinRequest'] as const;

export const getIdentityCreateJoinRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateJoinRequest>>, TError,IdentityCreateJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityCreateJoinRequest>>, TError,IdentityCreateJoinRequestMutationVariables, TContext> => {

const mutationKey = getIdentityCreateJoinRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityCreateJoinRequest>>, IdentityCreateJoinRequestMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  identityCreateJoinRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityCreateJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof identityCreateJoinRequest>>>
    export type IdentityCreateJoinRequestMutationBody = CreateJoinRequestDto
    export type IdentityCreateJoinRequestMutationError = unknown
    export type IdentityCreateJoinRequestMutationVariables = {data: CreateJoinRequestDto}

    export const useIdentityCreateJoinRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateJoinRequest>>, TError,IdentityCreateJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityCreateJoinRequest>>,
        TError,
        IdentityCreateJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityCreateJoinRequestMutationOptions(options), queryClient);
    }
    export const getIdentityWithdrawJoinRequestUrl = (id: string,) => {




  return `/v1/me/join-requests/${id}/withdraw`
}

export const identityWithdrawJoinRequest = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestDto> => {

  return oexFetch<JoinRequestDto>(getIdentityWithdrawJoinRequestUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityWithdrawJoinRequestMutationKey = () => ['identityWithdrawJoinRequest'] as const;

export const getIdentityWithdrawJoinRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityWithdrawJoinRequest>>, TError,IdentityWithdrawJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityWithdrawJoinRequest>>, TError,IdentityWithdrawJoinRequestMutationVariables, TContext> => {

const mutationKey = getIdentityWithdrawJoinRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityWithdrawJoinRequest>>, IdentityWithdrawJoinRequestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  identityWithdrawJoinRequest(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityWithdrawJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof identityWithdrawJoinRequest>>>

    export type IdentityWithdrawJoinRequestMutationError = unknown
    export type IdentityWithdrawJoinRequestMutationVariables = {id: string}

    export const useIdentityWithdrawJoinRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityWithdrawJoinRequest>>, TError,IdentityWithdrawJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityWithdrawJoinRequest>>,
        TError,
        IdentityWithdrawJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityWithdrawJoinRequestMutationOptions(options), queryClient);
    }
    export const getIdentityListInvitationsUrl = (id: string,) => {




  return `/v1/orgs/${id}/invitations`
}

export const identityListInvitations = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<InvitationListDto> => {

  return oexFetch<InvitationListDto>(getIdentityListInvitationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListInvitationsQueryKey = (id: string,) => {
    return [
    `/v1/orgs/${id}/invitations`
    ] as const;
    }


export const getIdentityListInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof identityListInvitations>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListInvitationsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListInvitations>>> = ({ signal }) => identityListInvitations(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListInvitations>>>
export type IdentityListInvitationsQueryError = unknown


export function useIdentityListInvitations<TData = Awaited<ReturnType<typeof identityListInvitations>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListInvitations>>,
          TError,
          Awaited<ReturnType<typeof identityListInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListInvitations<TData = Awaited<ReturnType<typeof identityListInvitations>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListInvitations>>,
          TError,
          Awaited<ReturnType<typeof identityListInvitations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListInvitations<TData = Awaited<ReturnType<typeof identityListInvitations>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListInvitations<TData = Awaited<ReturnType<typeof identityListInvitations>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListInvitations>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListInvitationsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityCreateInvitationUrl = (id: string,) => {




  return `/v1/orgs/${id}/invitations`
}

export const identityCreateInvitation = async (id: string,
    createInvitationDto: CreateInvitationDto, options?: Parameters<typeof oexFetch>[1]): Promise<InvitationDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<InvitationDto>(getIdentityCreateInvitationUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInvitationDto)
  }
);}





export const getIdentityCreateInvitationMutationKey = () => ['identityCreateInvitation'] as const;

export const getIdentityCreateInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateInvitation>>, TError,IdentityCreateInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityCreateInvitation>>, TError,IdentityCreateInvitationMutationVariables, TContext> => {

const mutationKey = getIdentityCreateInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityCreateInvitation>>, IdentityCreateInvitationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  identityCreateInvitation(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityCreateInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof identityCreateInvitation>>>
    export type IdentityCreateInvitationMutationBody = CreateInvitationDto
    export type IdentityCreateInvitationMutationError = unknown
    export type IdentityCreateInvitationMutationVariables = {id: string;data: CreateInvitationDto}

    export const useIdentityCreateInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateInvitation>>, TError,IdentityCreateInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityCreateInvitation>>,
        TError,
        IdentityCreateInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityCreateInvitationMutationOptions(options), queryClient);
    }
    export const getIdentityRevokeInvitationUrl = (id: string,
    invId: string,) => {




  return `/v1/orgs/${id}/invitations/${invId}`
}

export const identityRevokeInvitation = async (id: string,
    invId: string, options?: Parameters<typeof oexFetch>[1]): Promise<InvitationDto> => {

  return oexFetch<InvitationDto>(getIdentityRevokeInvitationUrl(id,invId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getIdentityRevokeInvitationMutationKey = () => ['identityRevokeInvitation'] as const;

export const getIdentityRevokeInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeInvitation>>, TError,IdentityRevokeInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityRevokeInvitation>>, TError,IdentityRevokeInvitationMutationVariables, TContext> => {

const mutationKey = getIdentityRevokeInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityRevokeInvitation>>, IdentityRevokeInvitationMutationVariables> = (props) => {
          const {id,invId} = props ?? {};

          return  identityRevokeInvitation(id,invId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityRevokeInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof identityRevokeInvitation>>>

    export type IdentityRevokeInvitationMutationError = unknown
    export type IdentityRevokeInvitationMutationVariables = {id: string;invId: string}

    export const useIdentityRevokeInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeInvitation>>, TError,IdentityRevokeInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityRevokeInvitation>>,
        TError,
        IdentityRevokeInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityRevokeInvitationMutationOptions(options), queryClient);
    }
    export const getIdentityResendInvitationUrl = (id: string,
    invId: string,) => {




  return `/v1/orgs/${id}/invitations/${invId}/resend`
}

export const identityResendInvitation = async (id: string,
    invId: string, options?: Parameters<typeof oexFetch>[1]): Promise<InvitationDto> => {

  return oexFetch<InvitationDto>(getIdentityResendInvitationUrl(id,invId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityResendInvitationMutationKey = () => ['identityResendInvitation'] as const;

export const getIdentityResendInvitationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityResendInvitation>>, TError,IdentityResendInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityResendInvitation>>, TError,IdentityResendInvitationMutationVariables, TContext> => {

const mutationKey = getIdentityResendInvitationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityResendInvitation>>, IdentityResendInvitationMutationVariables> = (props) => {
          const {id,invId} = props ?? {};

          return  identityResendInvitation(id,invId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityResendInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof identityResendInvitation>>>

    export type IdentityResendInvitationMutationError = unknown
    export type IdentityResendInvitationMutationVariables = {id: string;invId: string}

    export const useIdentityResendInvitation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityResendInvitation>>, TError,IdentityResendInvitationMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityResendInvitation>>,
        TError,
        IdentityResendInvitationMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityResendInvitationMutationOptions(options), queryClient);
    }
    export const getIdentityListJoinRequestsUrl = (id: string,) => {




  return `/v1/orgs/${id}/join-requests`
}

export const identityListJoinRequests = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestListDto> => {

  return oexFetch<JoinRequestListDto>(getIdentityListJoinRequestsUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListJoinRequestsQueryKey = (id: string,) => {
    return [
    `/v1/orgs/${id}/join-requests`
    ] as const;
    }


export const getIdentityListJoinRequestsQueryOptions = <TData = Awaited<ReturnType<typeof identityListJoinRequests>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListJoinRequestsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListJoinRequests>>> = ({ signal }) => identityListJoinRequests(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListJoinRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListJoinRequests>>>
export type IdentityListJoinRequestsQueryError = unknown


export function useIdentityListJoinRequests<TData = Awaited<ReturnType<typeof identityListJoinRequests>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListJoinRequests<TData = Awaited<ReturnType<typeof identityListJoinRequests>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListJoinRequests>>,
          TError,
          Awaited<ReturnType<typeof identityListJoinRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListJoinRequests<TData = Awaited<ReturnType<typeof identityListJoinRequests>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListJoinRequests<TData = Awaited<ReturnType<typeof identityListJoinRequests>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListJoinRequests>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListJoinRequestsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityDecideJoinRequestUrl = (id: string,
    jrId: string,) => {




  return `/v1/orgs/${id}/join-requests/${jrId}/decide`
}

export const identityDecideJoinRequest = async (id: string,
    jrId: string,
    decideJoinRequestDto: DecideJoinRequestDto, options?: Parameters<typeof oexFetch>[1]): Promise<JoinRequestDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<JoinRequestDto>(getIdentityDecideJoinRequestUrl(id,jrId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(decideJoinRequestDto)
  }
);}





export const getIdentityDecideJoinRequestMutationKey = () => ['identityDecideJoinRequest'] as const;

export const getIdentityDecideJoinRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityDecideJoinRequest>>, TError,IdentityDecideJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityDecideJoinRequest>>, TError,IdentityDecideJoinRequestMutationVariables, TContext> => {

const mutationKey = getIdentityDecideJoinRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityDecideJoinRequest>>, IdentityDecideJoinRequestMutationVariables> = (props) => {
          const {id,jrId,data} = props ?? {};

          return  identityDecideJoinRequest(id,jrId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityDecideJoinRequestMutationResult = NonNullable<Awaited<ReturnType<typeof identityDecideJoinRequest>>>
    export type IdentityDecideJoinRequestMutationBody = DecideJoinRequestDto
    export type IdentityDecideJoinRequestMutationError = unknown
    export type IdentityDecideJoinRequestMutationVariables = {id: string;jrId: string;data: DecideJoinRequestDto}

    export const useIdentityDecideJoinRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityDecideJoinRequest>>, TError,IdentityDecideJoinRequestMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityDecideJoinRequest>>,
        TError,
        IdentityDecideJoinRequestMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityDecideJoinRequestMutationOptions(options), queryClient);
    }
    export const getIdentityListMembersUrl = (id: string,) => {




  return `/v1/orgs/${id}/members`
}

export const identityListMembers = async (id: string, options?: Parameters<typeof oexFetch>[1]): Promise<MemberListDto> => {

  return oexFetch<MemberListDto>(getIdentityListMembersUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListMembersQueryKey = (id: string,) => {
    return [
    `/v1/orgs/${id}/members`
    ] as const;
    }


export const getIdentityListMembersQueryOptions = <TData = Awaited<ReturnType<typeof identityListMembers>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListMembersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListMembers>>> = ({ signal }) => identityListMembers(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListMembersQueryResult = NonNullable<Awaited<ReturnType<typeof identityListMembers>>>
export type IdentityListMembersQueryError = unknown


export function useIdentityListMembers<TData = Awaited<ReturnType<typeof identityListMembers>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListMembers>>,
          TError,
          Awaited<ReturnType<typeof identityListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListMembers<TData = Awaited<ReturnType<typeof identityListMembers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListMembers>>,
          TError,
          Awaited<ReturnType<typeof identityListMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListMembers<TData = Awaited<ReturnType<typeof identityListMembers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListMembers<TData = Awaited<ReturnType<typeof identityListMembers>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListMembers>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListMembersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityUpdateMemberUrl = (id: string,
    userId: string,) => {




  return `/v1/orgs/${id}/members/${userId}`
}

export const identityUpdateMember = async (id: string,
    userId: string,
    updateMemberDto: UpdateMemberDto, options?: Parameters<typeof oexFetch>[1]): Promise<MemberDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<MemberDto>(getIdentityUpdateMemberUrl(id,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMemberDto)
  }
);}





export const getIdentityUpdateMemberMutationKey = () => ['identityUpdateMember'] as const;

export const getIdentityUpdateMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMember>>, TError,IdentityUpdateMemberMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMember>>, TError,IdentityUpdateMemberMutationVariables, TContext> => {

const mutationKey = getIdentityUpdateMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityUpdateMember>>, IdentityUpdateMemberMutationVariables> = (props) => {
          const {id,userId,data} = props ?? {};

          return  identityUpdateMember(id,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityUpdateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof identityUpdateMember>>>
    export type IdentityUpdateMemberMutationBody = UpdateMemberDto
    export type IdentityUpdateMemberMutationError = unknown
    export type IdentityUpdateMemberMutationVariables = {id: string;userId: string;data: UpdateMemberDto}

    export const useIdentityUpdateMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityUpdateMember>>, TError,IdentityUpdateMemberMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityUpdateMember>>,
        TError,
        IdentityUpdateMemberMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityUpdateMemberMutationOptions(options), queryClient);
    }
    export const getIdentityRemoveMemberUrl = (id: string,
    userId: string,) => {




  return `/v1/orgs/${id}/members/${userId}`
}

export const identityRemoveMember = async (id: string,
    userId: string, options?: Parameters<typeof oexFetch>[1]): Promise<RemoveMemberResultDto> => {

  return oexFetch<RemoveMemberResultDto>(getIdentityRemoveMemberUrl(id,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getIdentityRemoveMemberMutationKey = () => ['identityRemoveMember'] as const;

export const getIdentityRemoveMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRemoveMember>>, TError,IdentityRemoveMemberMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityRemoveMember>>, TError,IdentityRemoveMemberMutationVariables, TContext> => {

const mutationKey = getIdentityRemoveMemberMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityRemoveMember>>, IdentityRemoveMemberMutationVariables> = (props) => {
          const {id,userId} = props ?? {};

          return  identityRemoveMember(id,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof identityRemoveMember>>>

    export type IdentityRemoveMemberMutationError = unknown
    export type IdentityRemoveMemberMutationVariables = {id: string;userId: string}

    export const useIdentityRemoveMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRemoveMember>>, TError,IdentityRemoveMemberMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityRemoveMember>>,
        TError,
        IdentityRemoveMemberMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityRemoveMemberMutationOptions(options), queryClient);
    }
    export const getIdentityListGrantsUrl = (id: string,
    userId: string,) => {




  return `/v1/orgs/${id}/members/${userId}/grants`
}

export const identityListGrants = async (id: string,
    userId: string, options?: Parameters<typeof oexFetch>[1]): Promise<PermissionGrantListDto> => {

  return oexFetch<PermissionGrantListDto>(getIdentityListGrantsUrl(id,userId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getIdentityListGrantsQueryKey = (id: string,
    userId: string,) => {
    return [
    `/v1/orgs/${id}/members/${userId}/grants`
    ] as const;
    }


export const getIdentityListGrantsQueryOptions = <TData = Awaited<ReturnType<typeof identityListGrants>>, TError = unknown>(id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIdentityListGrantsQueryKey(id,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof identityListGrants>>> = ({ signal }) => identityListGrants(id,userId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IdentityListGrantsQueryResult = NonNullable<Awaited<ReturnType<typeof identityListGrants>>>
export type IdentityListGrantsQueryError = unknown


export function useIdentityListGrants<TData = Awaited<ReturnType<typeof identityListGrants>>, TError = unknown>(
 id: string,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListGrants>>,
          TError,
          Awaited<ReturnType<typeof identityListGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListGrants<TData = Awaited<ReturnType<typeof identityListGrants>>, TError = unknown>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof identityListGrants>>,
          TError,
          Awaited<ReturnType<typeof identityListGrants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIdentityListGrants<TData = Awaited<ReturnType<typeof identityListGrants>>, TError = unknown>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useIdentityListGrants<TData = Awaited<ReturnType<typeof identityListGrants>>, TError = unknown>(
 id: string,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof identityListGrants>>, TError, TData>>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIdentityListGrantsQueryOptions(id,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIdentityCreateGrantUrl = (id: string,
    userId: string,) => {




  return `/v1/orgs/${id}/members/${userId}/grants`
}

export const identityCreateGrant = async (id: string,
    userId: string,
    createGrantDto: CreateGrantDto, options?: Parameters<typeof oexFetch>[1]): Promise<PermissionGrantDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<PermissionGrantDto>(getIdentityCreateGrantUrl(id,userId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createGrantDto)
  }
);}





export const getIdentityCreateGrantMutationKey = () => ['identityCreateGrant'] as const;

export const getIdentityCreateGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateGrant>>, TError,IdentityCreateGrantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityCreateGrant>>, TError,IdentityCreateGrantMutationVariables, TContext> => {

const mutationKey = getIdentityCreateGrantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityCreateGrant>>, IdentityCreateGrantMutationVariables> = (props) => {
          const {id,userId,data} = props ?? {};

          return  identityCreateGrant(id,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityCreateGrantMutationResult = NonNullable<Awaited<ReturnType<typeof identityCreateGrant>>>
    export type IdentityCreateGrantMutationBody = CreateGrantDto
    export type IdentityCreateGrantMutationError = unknown
    export type IdentityCreateGrantMutationVariables = {id: string;userId: string;data: CreateGrantDto}

    export const useIdentityCreateGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityCreateGrant>>, TError,IdentityCreateGrantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityCreateGrant>>,
        TError,
        IdentityCreateGrantMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityCreateGrantMutationOptions(options), queryClient);
    }
    export const getIdentityRevokeGrantUrl = (id: string,
    userId: string,
    grantId: string,) => {




  return `/v1/orgs/${id}/members/${userId}/grants/${grantId}`
}

export const identityRevokeGrant = async (id: string,
    userId: string,
    grantId: string, options?: Parameters<typeof oexFetch>[1]): Promise<PermissionGrantDto> => {

  return oexFetch<PermissionGrantDto>(getIdentityRevokeGrantUrl(id,userId,grantId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getIdentityRevokeGrantMutationKey = () => ['identityRevokeGrant'] as const;

export const getIdentityRevokeGrantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeGrant>>, TError,IdentityRevokeGrantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityRevokeGrant>>, TError,IdentityRevokeGrantMutationVariables, TContext> => {

const mutationKey = getIdentityRevokeGrantMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityRevokeGrant>>, IdentityRevokeGrantMutationVariables> = (props) => {
          const {id,userId,grantId} = props ?? {};

          return  identityRevokeGrant(id,userId,grantId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityRevokeGrantMutationResult = NonNullable<Awaited<ReturnType<typeof identityRevokeGrant>>>

    export type IdentityRevokeGrantMutationError = unknown
    export type IdentityRevokeGrantMutationVariables = {id: string;userId: string;grantId: string}

    export const useIdentityRevokeGrant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityRevokeGrant>>, TError,IdentityRevokeGrantMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityRevokeGrant>>,
        TError,
        IdentityRevokeGrantMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityRevokeGrantMutationOptions(options), queryClient);
    }
    export const getIdentityTransferOwnershipUrl = (id: string,) => {




  return `/v1/orgs/${id}/ownership-transfer`
}

export const identityTransferOwnership = async (id: string,
    transferOwnershipDto: TransferOwnershipDto, options?: Parameters<typeof oexFetch>[1]): Promise<OwnershipTransferResultDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return oexFetch<OwnershipTransferResultDto>(getIdentityTransferOwnershipUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(transferOwnershipDto)
  }
);}





export const getIdentityTransferOwnershipMutationKey = () => ['identityTransferOwnership'] as const;

export const getIdentityTransferOwnershipMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityTransferOwnership>>, TError,IdentityTransferOwnershipMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityTransferOwnership>>, TError,IdentityTransferOwnershipMutationVariables, TContext> => {

const mutationKey = getIdentityTransferOwnershipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityTransferOwnership>>, IdentityTransferOwnershipMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  identityTransferOwnership(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityTransferOwnershipMutationResult = NonNullable<Awaited<ReturnType<typeof identityTransferOwnership>>>
    export type IdentityTransferOwnershipMutationBody = TransferOwnershipDto
    export type IdentityTransferOwnershipMutationError = unknown
    export type IdentityTransferOwnershipMutationVariables = {id: string;data: TransferOwnershipDto}

    export const useIdentityTransferOwnership = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityTransferOwnership>>, TError,IdentityTransferOwnershipMutationVariables, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityTransferOwnership>>,
        TError,
        IdentityTransferOwnershipMutationVariables,
        TContext
      > => {
      return useMutation(getIdentityTransferOwnershipMutationOptions(options), queryClient);
    }
    export const getIdentityReceiveWorkosWebhookUrl = () => {




  return `/v1/webhooks/workos`
}

/**
 * @summary WorkOS user.* webhooks (signature-verified)
 */
export const identityReceiveWorkosWebhook = async ( options?: Parameters<typeof oexFetch>[1]): Promise<WebhookAckDto> => {

  return oexFetch<WebhookAckDto>(getIdentityReceiveWorkosWebhookUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getIdentityReceiveWorkosWebhookMutationKey = () => ['identityReceiveWorkosWebhook'] as const;

export const getIdentityReceiveWorkosWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof oexFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>, TError,void, TContext> => {

const mutationKey = getIdentityReceiveWorkosWebhookMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>, void> = () => {


          return  identityReceiveWorkosWebhook(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IdentityReceiveWorkosWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>>

    export type IdentityReceiveWorkosWebhookMutationError = unknown


    /**
 * @summary WorkOS user.* webhooks (signature-verified)
 */
export const useIdentityReceiveWorkosWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof oexFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof identityReceiveWorkosWebhook>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getIdentityReceiveWorkosWebhookMutationOptions(options), queryClient);
    }
